import * as React from "react";
const SvgIcPlay = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M22 12L6 2V22L22 12ZM16.3396 12L9 7.41274V16.5873L16.3396 12Z" fill="currentColor" /></svg>;
export default SvgIcPlay;